export default __webpack_public_path__ + "static/media/38.180f2c52.jpeg";